/*!
 * SAP UI development toolkit for HTML5 (SAPUI5)
 *  * (c) Copyright 2009-2025 SAP SE. All rights reserved
 */
import CoreLib from "sap/ui/core/Lib";
import "sap/ui/core/library";

const thisLib = CoreLib.init({
	name: "sap.cards.ap.transpiler",
	version: "${version}",
	dependencies: ["sap.ui.core"],
	types: [],
	apiVersion: 2,
	interfaces: [],
	controls: [],
	elements: [],
	noLibraryCSS: true
});

export default thisLib;
